import React, { ChangeEvent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface Option {
  value: string | number;
  label: string;
}

interface CustomSelectProps {
  options: Option[];
  placeholder: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  value: string | number;
  icon: IconDefinition;
  className?: string;
  disabled?: boolean;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  placeholder,
  onChange,
  value,
  icon,
  className,
  disabled
}) => {
  return (
    <div className={classNames(styles.selectContainer, className)}>
      <select
        className={styles.select}
        value={value}
        onChange={onChange}
        disabled={!!disabled}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={icon} />
      </div>
    </div>
  );
};

export default CustomSelect;
